<!--
 * @Author: your name
 * @Date: 2022-03-15 17:07:27
 * @LastEditTime: 2022-03-30 20:58:35
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\intro\DAOFund.vue
-->
<template>
  <!-- 获取DAO基金页面 -->
  <div>
    <div class="fund" ref="element">
      <div class="fund-all">
        <div class="fund-header">
          <p>{{ $t("Fund.title") }}</p>
        </div>
        <div class="fund-organization">
          <p>{{ $t("DAOFund.What") }}</p>
        </div>
        <div class="fund-text">
          <p>{{ $t("DAOFund.fund") }}</p>
        </div>
        <div>
          <div class="Start-Building">
            <p>
              {{ $t("DAOFund.Startbuilding") }}
              <img src="../../../assets/pc/intro/箭头.png" alt="" />
            </p>
            <div class="Start-Building-rigth">
              <img src="../../../assets/pc/intro/短.png" alt="" />
              <img src="../../../assets/pc/intro/中.png" alt="" />
              <img src="../../../assets/pc/intro/长.png" alt="" />
            </div>
          </div>
        </div>
        <div class="clearfix">
          <a href="https://www.donetwork.io/doc/">
            <div class="documentotin-all">
            <div class="documentotin-imgs">
              <img
                src="../../../assets/pc/intro/View developer documentation.svg"
                alt=""
                class="img1"
              />
            </div>
            <div class="text-p-all">
              <p class="documentotin-p1">{{ $t("DAOFund.developer") }}</p>
              <p class="documentotin-p2">
                {{ $t("DAOFund.Learn") }}
              </p>
            </div>
          </div>
          </a>
          
          <div class="documentotin-all center" @click="promptDilaogBox">
            <div class="documentotin-imgs">
              <img
                src="../../../assets/pc/intro/Deploy DAO application.svg"
                alt=""
                class="img2"
              />
            </div>
            <div class="text-p-all">
              <p class="documentotin-p1">{{ $t("DAOFund.Deploy") }}</p>
              <p class="documentotin-p2">
                {{ $t("DAOFund.Developers") }}
              </p>
            </div>
          </div>
          <div class="documentotin-all" @click="promptDilaogBox">
            <div class="documentotin-imgs">
              <img src="../../../assets/pc/intro/Interface tool.svg" alt="" class="img3" />
            </div>
            <div class="text-p-all">
              <p class="documentotin-p1">{{ $t("DAOFund.Interface") }}</p>
              <p class="documentotin-p2">
                {{ $t("DAOFund.Provides") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: divH}" class="all"  v-show="flog"   @touchmove.prevent @mousewheel.prevent>
      <div class="active">
      <div class="promptDilaogBox">
        <p>in building</p>
        <p @click="promptDilaogBoxBtn" class="promptDilaogBoxBtn">ok</p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flog: false,
      timeout: "",
      // divW: document.body.clientWidth,
      divH: 0,
      active: false,
    }
  },
  methods:{
    promptDilaogBoxBtn() {
      this.flog = false;
      
    },
    promptDilaogBox() {
      this.flog = true;
      this.divH = this.$refs.element.offsetHeight + 1200 + "px";
      console.log(this.diaH);
    },
    
  }
  
};
</script>
<style lang="less">
.w1352 {
  width: 1190px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
* {
  margin: 0;
  padding: 0;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.fund {
  background: url(../../../assets/pc/intro/back.png) no-repeat center / 100%
    100%;
    background-size: 100%;
  // background-position: 0 0;
  padding-bottom: 340px;
}
.fund-all {
  width: 1190px;
  padding: 231px 0 0 0;
  margin: 0 auto;
  .fund-header {
    font-size: 80px;
    font-family: Poppins-Black, Poppins;
    font-weight: 900;
    color: #000000;
    line-height: 103px;
    -webkit-background-clip: text;
  }
  .fund-organization {
    font-size: 24px;
    font-weight: 500;
    margin: 45px 0 22px 0;
    color: #000;
    line-height: 28px;
    font-family: Poppins-Medium, Poppins;
    -webkit-background-clip: text;
  }
  .fund-text {
    margin-bottom: 90px;
    font-size: 18px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #61666b;
    line-height: 30px;
    -webkit-background-clip: text;
  }
  .Start-Building {
    width: 100%;
    height: 200px;
    text-align: left;
    background-color: #4b7ceb;
    box-sizing: border-box;
    border-radius: 20px;
    p {
      font-size: 45px;
      color: #fff;
      font-weight: 700;
      line-height: 200px;
      padding-left: 62px;
      float: left;
      img {
        width: 32px;
        height: 32px;
        margin-left: 5px;
        margin-top: 25%;
      }
    }
    .Start-Building-rigth {
      margin: 16px 48px 0 0;
      float: right;
      img:nth-child(2) {
        margin: 20% 30px 0 30px;
      }
      img:nth-child(1) {
        margin-top: 43%;
      }
    }
  }
  .documentotin-all {
    width: 380px;
    height: 225px;
    border-radius: 15px;
    color: #000;
    margin: 150px 0 0 0;
    float: left;
    background: rgba(238, 239, 245, 0.3);
    opacity: 1;
    border: 2px solid #e4e4e6;
    cursor:pointer ;
    .documentotin-imgs {
      width: 41.9px;
      height: 42.94px;
      margin: 36px 0 11px 30px;
      // background-color: #4573e7;
      text-align: center;
      .img1{
        width: 41.9px;
        height: 42.94px;
      }
      .img2{
        width:  43.79px;
        height: 40.42px;
      }
      .img3{
        width: 47.53px;
        height: 47.53px;
      }
    }
    .text-p-all {
      margin-left: 30px;
      .documentotin-p1 {
        font-size: 18px;
        font-family: Poppins-SemiBold, Poppins;
        font-weight: 600;
        color: #2c1d1a;
        line-height: 31px;
        -webkit-background-clip: text;
      }
      .documentotin-p2 {
        width: 325px;
        height: 72px;
        font-size: 14px;
        color: #737582;
        line-height: 23.8px;
        font-weight: 500;
      }
    }
  }
  .center {
    margin: 150px 25px 0 25px;
  }
  .documentotin-all:hover {
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.3);
    border: 2px solid #527ce9;
    box-shadow: 0px 7px 35px 1px rgba(69, 115, 231, 0.2);
  }
}
// 隐藏弹框样式
.all {
  width: 100%;
  background: rgba(4, 13, 35, 0.15000000596046448);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 998 !important;
  
}
.promptDilaogBox {
  width: 305px;
  height: 180px;
  background: #f4f5f7;
  border-top: 10px solid #4573e7;
  box-sizing: border-box;
  padding: 47px 98px;
  text-align: center;
  cursor:pointer;
  p {
    text-align: center;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #2b2d41;
    margin: 0;
  }
  .promptDilaogBoxBtn {
    margin-top: 36px;
    width: 110px;
    height: 40px;
    background: #4573e7;
    border-radius: 5px 5px 5px 5px;
    border: none;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    box-sizing: border-box;
    line-height: 40px;
    cursor:pointer;
  }
}
.active {
  position: absolute;
  top: 30%;
  left: 40%;
  // transform: translate(75%, 60%);
}
</style>
